import React, { useEffect, useState, useRef } from 'react';
import { usePusher } from '../../App';

import {
  Tooltip,
  IconButton,
  CircularProgress,
  Checkbox,
  Button,
  styled,
} from '@material-ui/core';
import {
  DeleteRounded,
  CreateRounded,
  Share as ShareIcon,
} from '@material-ui/icons';
import { fDate, fTimeDate } from '@/actions/Helper';
import styles from './styles';
import Containers from './Containers';
import Share from './Share/index';
import TableDroppedList from './TableDroppedList';
import {
  disableInventoryContainer,
  enableInventoryContainer,
  getInventoryShareLink,
  SaveApiResMessage,
} from '@/actions';
import { useNotify } from 'react-admin';
import { useSelector } from 'react-redux';
import { ReactSVG } from 'react-svg';
import { Icons } from '@/assets';
import clsx from 'clsx';
import TableLoadList from './TableLoadList';
import PageContainerTabs from '@/components/PageContainerTabs';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import LoadingV2 from '@/components/Loading';

export default ({
  DATA = [],
  Del,
  DelContainer,
  DelContainerLoad,
  // deleteall,
  Edit,
  getInventoryList,
  getInventoryListNotLoading,
  currentPage,
  tableTheadTitle,
  mptyTrackingEnable,
  enable_appointments,
  Appointment,
  activeTab,
  formatDateTimeToUTC,
  setActiveTab,
  Sizes = [],
  SSLs = [],
  updateContainer,
}) => {
  const cls = styles();
  const [containersData, setContainersData] = useState(DATA);
  const { channels } = usePusher();
  const [showContainersModal, setShowContainersModal] = useState(false);
  const [shareModal, setShareModal] = useState(false);
  const [timerinterval, setTimerInterval] = useState({});
  const [selectedRow, setSelectedRow] = useState(null);
  // const [enable_empty_tracking, setEnable_empty_tracking] = useState(null);
  const [shareLink, setShareLink] = useState({
    loading: null,
    DATA: null,
  });
  const tabParams = useParams();

  useEffect(() => {
    // setContainersData(DATA);
    if (tabParams.tab === 'all') {
      setActiveTab('all');
    } else if (tabParams.tab === 'dropped') {
      setActiveTab('dropped');
    }
  }, [tabParams]);

  function replaceContainerById(containersData, updatedContainer) {
    for (let containerGroup of containersData) {
      const index = containerGroup.containers.findIndex(
        (container) => container.id === updatedContainer.id
      );
      if (index !== -1) {
        containerGroup.containers[index] = updatedContainer;
        break; // Exit loop once the container is updated
      }
    }
    return containersData;
  }

  useEffect(() => {
    if (channels?.privateChannel) {
      channels.privateChannel.bind('Empty', (data) => {
        const updatedContainer = data.message.container;

        const updatedContainersData = replaceContainerById(
          containersData,
          updatedContainer
        );

        setContainersData(updatedContainersData);
      });

      return () => {
        channels.privateChannel.unbind('Empty');
      };
    }
  }, [channels, containersData]);

  useEffect(() => {
    setContainersData(DATA);
  }, [DATA]);

  const notify = useNotify();

  const updateNotif = useSelector((state) =>
    state.reducer.notif ? state.reducer.notif : null
  );
  const updateNotif11 = useSelector((state) =>
    state.reducer.containerData ? state.reducer.containerData : null
  );

  const empty_trackingState = useSelector((state) => {
    if (state) {
      const stateRes = state.reducer?.user.metas?.enable_empty_tracking?.value;
      // console.log('stateRes', stateRes);

      return stateRes;
    }
  });
  const user = useSelector((state) => {
    if (state) {
      const user = state.reducer?.user.id;
      // console.log('user', user);
      return user;
    }
  });
  // useEffect(() => {
  //   setEnable_empty_tracking(empty_trackingState);
  //   // console.log('user', user);
  // }, [empty_trackingState]);

  useEffect(() => {
    if (
      updateNotif11?.container?.gated_out ||
      updateNotif11?.container?.gated_in
    ) {
      getInventoryListNotLoading();
      // notify('Containers Data Updated.');
      SaveApiResMessage({
        title: null,
        message: 'Containers Data Updated.',
        mode: 'success',
      });
    }
  }, []);

  // const formatDateTimeToUTC = (dateString) => {
  //   const date = new Date(dateString);
  //   const hours = date.getUTCHours();
  //   const minutes = date.getUTCMinutes();
  //   const formattedDate =
  //     `${String(date.getUTCMonth() + 1).padStart(2, '0')}-` + // Months are zero-based
  //     `${String(date.getUTCDate()).padStart(2, '0')}-` +
  //     `${String(date.getUTCFullYear()).slice(-2)}`; // Slice the last two digits for the year

  //   // Check if both hours and minutes are 00
  //   if (hours === 0 && minutes === 0) {
  //     return formattedDate; // Return only the date
  //   } else {
  //     return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(
  //       2,
  //       '0'
  //     )} ${formattedDate}`; // Return time and date
  //   }
  // };

  const formatDateToUTC = (dateString) => {
    const date = new Date(dateString);
    const formattedDate =
      `${String(date.getUTCMonth() + 1).padStart(2, '0')}-` + // Months are zero-based
      `${String(date.getUTCDate()).padStart(2, '0')}-` +
      `${String(date.getUTCFullYear()).padStart(2, '0')} `;

    return formattedDate;
  };

  const formatPrice = (price) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(price);
  };

  const handleEnableCongtainer = (containerId, index) => {
    enableInventoryContainer(containerId).then((response) => {
      if (response.success) {
        // notify('container updated');
        SaveApiResMessage({
          title: response?.messageHeader,
          message: 'container updated',
          mode: 'success',
        });
        // updateContainers(index, 'status', 1);
        // setRefreshInventories(true);
        getInventoryListNotLoading();
      } else {
        // notify('somthing went wrong!');
        SaveApiResMessage({
          title: 'Error',
          message: 'somthing went wrong!',
          mode: 'error',
        });
      }
    });
  };

  const handleDisableContainer = (containerId, index) => {
    disableInventoryContainer(containerId).then((response) => {
      if (response.success) {
        // notify('container updated');
        SaveApiResMessage({
          title: response?.messageHeader,
          message: 'container updated',
          mode: 'success',
        });
        // updateContainers(index, 'status', 0);
        // setRefreshInventories(true);
        getInventoryListNotLoading();
      } else {
        // notify('somthing went wrong!');
        SaveApiResMessage({
          title: 'Error',
          message: 'somthing went wrong!',
          mode: 'error',
        });
      }
    });
  };

  const handleChangeContainerStatus = (value, containerId, index) => {
    if (value === true) {
      handleEnableCongtainer(containerId, index);
    } else {
      handleDisableContainer(containerId, index);
    }
  };

  const getActivContainers = (inventory, target) => {
    if (inventory) {
      let activeContainers = [];
      let deactiveContainers = [];
      inventory.containers.forEach((container) => {
        if (container.status === 1) {
          activeContainers.push(container);
        } else if (container.status === 0) {
          deactiveContainers.push(container);
        }
      });

      if (deactiveContainers.length === 0) {
        return (
          <input
            type="checkbox"
            className={`all ${cls.containerChecBox}`}
            checked={true}
          />
        );
      } else if (activeContainers.length === 0) {
        return (
          <input
            type="checkbox"
            className={`any ${cls.containerChecBox}`}
            checked={false}
          />
        );
      } else {
        return (
          <input
            type="checkbox"
            checked={true}
            className={`some ${cls.containerChecBox}`}
          />
        );
      }
    }
  };

  const handleGetShareLink = (containerId) => {
    setShareLink({ loading: containerId });
    getInventoryShareLink(containerId)
      .then((res) => {
        setShareModal(containerId);
        setShareLink({
          loading: null,
          DATA: res,
        });
      })
      .catch((err) => {
        setShareLink({ loading: null });
        // notify(err, 'warning');
        SaveApiResMessage({
          title: 'Error',
          message: err,
          mode: 'warning',
        });
      });
  };

  useEffect(() => {
    let someCompletedCheckboxs = document.getElementsByClassName('some');
    let allCompletedCheckboxs = document.getElementsByClassName('all');
    let notCompletedCheckboxs = document.getElementsByClassName('any');
    for (let i = 0; i < someCompletedCheckboxs.length; i++) {
      someCompletedCheckboxs[i].indeterminate = true;
    }
    for (let i = 0; i < allCompletedCheckboxs.length; i++) {
      allCompletedCheckboxs[i].indeterminate = false;
    }
    for (let i = 0; i < notCompletedCheckboxs.length; i++) {
      notCompletedCheckboxs[i].indeterminate = false;
      notCompletedCheckboxs[i].checked = false;
    }
  }, []);
  let uniqueIndex = 0;

  // const [progress, setProgress] = useState(0);
  // const [fastProgress, setFastProgress] = useState(0);

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setProgress((prev) => {
  //       if (prev >= 100) {
  //         clearInterval(interval);
  //         return 100;
  //       }
  //       return prev + 0.1667;
  //     });
  //   }, 1000);

  //   return () => clearInterval(interval);
  // }, []);

  // useEffect(() => {
  //   let fastInterval; // Define fastInterval outside the function

  //   const startFastProgress = () => {
  //     fastInterval = setInterval(() => {
  //       setFastProgress((prev) => {
  //         if (prev >= 100) {
  //           clearInterval(fastInterval); // Stop the interval when progress reaches 100
  //           setFastProgress(0); // Reset progress to 0
  //           startFastProgress(); // Restart the progress
  //           return 0;
  //         }
  //         return prev + 1.6667; // Increment by 1.6667 every 10 milliseconds
  //       });
  //     }, 30); // 10 milliseconds interval
  //   };

  //   startFastProgress(); // Start the progress initially

  //   return () => {
  //     clearInterval(fastInterval); // Cleanup interval on component unmount
  //   };
  // }, []);

  // Helper function to calculate the difference in minutes
  // const getMinutesDiff = (time1, time2) => {
  //   const diff = Math.abs(new Date(time2) - new Date(time1));
  //   return Math.floor(diff / 60000); // Convert milliseconds to minutes
  // };

  // const [timers, setTimers] = useState({});

  // const startTimers = () => {
  //   if (containersData) {
  //     containersData.forEach((i) => {
  //       if (i && i.containers) {
  //         i.containers.forEach((container, idd) => {
  //           const timerKey = `timer_${container.id}`;
  //           const lastUpdate = container.scr_next;
  //           const lastScrape = container.scr_last;
  //           const elapsedMinutes = getMinutesDiff(lastUpdate, new Date());
  //           if (
  //             lastScrape !== null ||
  //             container.gated_out !== null ||
  //             container.gated_in !== null ||
  //             elapsedMinutes > 10 ||
  //             container.create_type === 'SYSTEMIC'
  //           ) {
  //             localStorage.removeItem(timerKey);
  //             setTimerInterval((prevState) => ({
  //               ...prevState,
  //               [timerKey]: 0, // Restart timer from 0
  //             }));
  //           } else {
  //             let storedTime = parseInt(localStorage.getItem(timerKey)) || 0;

  //             if (storedTime + elapsedMinutes >= 600) {
  //               updateCheckAmirbio();
  //               localStorage.removeItem(timerKey);
  //             } else {
  //               storedTime += elapsedMinutes;
  //               localStorage.setItem(timerKey, storedTime);

  //               const interval = setInterval(() => {
  //                 storedTime += 1;
  //                 localStorage.setItem(timerKey, storedTime);
  //                 // Update the state for each timer
  //                 setTimerInterval((prevState) => ({
  //                   ...prevState,
  //                   [timerKey]: storedTime,
  //                 }));

  //                 if (container.gated_out) {
  //                   clearInterval(interval);
  //                   localStorage.removeItem(timerKey);
  //                 }
  //               }, 1000);
  //             }
  //           }
  //         });
  //       }
  //     });
  //   }
  // };

  // const updateCheckAmirbio = () => {};

  // useEffect(() => {
  //   if (activeTab === 'dropped') {
  //     startTimers();
  //   }
  // }, [DATA, containersData, activeTab]);

  const amirbiosRef = useRef(null);
  const tableRef = useRef(null);
  const amirbios1Ref = useRef(null);
  const amirbios2Ref = useRef(null);
  const mainScroll = document.getElementsByTagName('main')[0];
  const [tableWidth, setTableWidth] = useState(0);
  const [spanWidth, setSpanWidth] = useState(0);

  useEffect(() => {
    const amirbiosTop = amirbiosRef.current.getBoundingClientRect().top;

    const handleScroll = () => {
      if (amirbiosRef.current && amirbios1Ref.current) {
        const amirbiosTop = amirbiosRef.current.getBoundingClientRect().top;

        if (amirbiosTop <= 90) {
          amirbios2Ref.current.classList.add(cls.fix);
          tableRef.current.classList.add(cls.tableTopMargin);
        } else {
          amirbios2Ref.current.classList.remove(cls.fix);
          tableRef.current.classList.remove(cls.tableTopMargin);
        }
      }
      syncScroll('amirbios');
    };
    const updateWidth = () => {
      if (tableRef.current && amirbios1Ref.current) {
        const tableCurrentWidth =
          tableRef.current.getBoundingClientRect().width;
        setTableWidth(tableCurrentWidth);
      }
    };

    const updateHeadWidth = () => {
      if (amirbiosRef.current && amirbios2Ref.current) {
        const tableeCurrentWidth =
          amirbiosRef.current.getBoundingClientRect().width;
        setSpanWidth(tableeCurrentWidth);
      }
    };

    const syncScroll = (source) => {
      if (amirbiosRef.current || amirbios2Ref.current) {
        if (source === 'amirbios') {
          amirbios2Ref.current.scrollLeft = amirbiosRef.current.scrollLeft;
        } else if (source === 'amirbios2') {
          amirbiosRef.current.scrollLeft = amirbios2Ref.current.scrollLeft;
        }
      }
    };

    setTimeout(() => {
      updateWidth();
      updateHeadWidth();
    }, 100);

    window.updateWidth = updateWidth;
    window.updateHeadWidth = updateHeadWidth;
    window.syncScroll = syncScroll;

    const handleScroll1 = () => syncScroll('amirbios');
    const handleScroll2 = () => syncScroll('amirbios2');

    if (amirbiosRef.current) {
      amirbiosRef.current.addEventListener('scroll', handleScroll1);
    }

    if (amirbios1Ref.current) {
      amirbios2Ref.current.addEventListener('scroll', handleScroll2);
    }

    mainScroll.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', updateWidth);
    window.addEventListener('resize', updateHeadWidth);
    mainScroll.addEventListener('scroll', updateWidth);
    mainScroll.addEventListener('scroll', updateHeadWidth);

    // Cleanup on component unmount
    return () => {
      mainScroll.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', updateWidth);
      window.removeEventListener('resize', updateHeadWidth);
      mainScroll.removeEventListener('scroll', updateWidth);
      mainScroll.removeEventListener('scroll', updateHeadWidth);

      if (amirbiosRef.current) {
        amirbiosRef.current.removeEventListener('scroll', handleScroll1);
      }

      if (amirbios2Ref.current) {
        amirbios2Ref.current.removeEventListener('scroll', handleScroll2);
      }

      // if (amirbios2Ref.current) {
      //   amirbios2Ref.current.removeEventListener('scroll', () =>
      //     syncScroll('amirbios2')
      //   );
      // }
    };
  }, [
    DATA,
    tableTheadTitle,
    cls.fix,
    cls.tableTopMargin,
    tableWidth,
    spanWidth,
    containersData,
    amirbiosRef,
    amirbios2Ref,
    tableTheadTitle,
    mptyTrackingEnable,
    enable_appointments,
    Appointment,
  ]);

  useEffect(() => {
    if (amirbios2Ref.current) {
      amirbios2Ref.current.style.width = `${spanWidth - 2}px`;
    }
  }, [spanWidth, DATA]);

  useEffect(() => {
    if (amirbios1Ref.current) {
      amirbios1Ref.current.style.width = `${tableWidth - 7}px`;
    }
  }, [tableWidth, amirbios1Ref, DATA]);

  const CustomButton = styled(Button)(({ theme }) => ({
    '& > span': {
      display: 'block',
      textAlign: 'center',
    },
  }));

  return (
    <div ref={amirbiosRef} id="amirbios" className={cls.listContainer}>
      {showContainersModal && selectedRow && (
        <Containers
          open={showContainersModal}
          DATA={containersData}
          selectedRow={selectedRow}
          setShowContainersModal={setShowContainersModal}
          getInventoryList={getInventoryList}
        />
      )}
      {shareModal && !shareLink.loading && (
        <Share
          shareLink={shareLink}
          shareModal={shareModal}
          setShareModal={setShareModal}
        />
      )}
      {activeTab === 'dropped' ? (
        <TableDroppedList
          cls={cls}
          tableRef={tableRef}
          amirbios2Ref={amirbios2Ref}
          amirbios1Ref={amirbios1Ref}
          activeTab={activeTab}
          tableTheadTitle={tableTheadTitle}
          containersData={containersData}
          currentPage={currentPage}
          uniqueIndex={uniqueIndex}
          formatDateTimeToUTC={formatDateTimeToUTC}
          formatDateToUTC={formatDateToUTC}
          formatPrice={formatPrice}
          fDate={fDate}
          fTimeDate={fTimeDate}
          enable_appointments={enable_appointments}
          showContainersModal={showContainersModal}
          Appointment={Appointment}
          shareLink={shareLink}
          handleGetShareLink={handleGetShareLink}
          Edit={Edit}
          DelContainer={DelContainer}
          handleChangeContainerStatus={handleChangeContainerStatus}
          timerinterval={timerinterval}
          // fastProgress={fastProgress}
          getActivContainers={getActivContainers}
          setShowContainersModal={setShowContainersModal}
          setSelectedRow={setSelectedRow}
          Del={Del}
          mptyTrackingEnable={mptyTrackingEnable}
        />
      ) : activeTab === 'all' ? (
        <TableLoadList
          cls={cls}
          tableRef={tableRef}
          amirbios2Ref={amirbios2Ref}
          amirbios1Ref={amirbios1Ref}
          activeTab={activeTab}
          tableTheadTitle={tableTheadTitle}
          containersData={containersData}
          currentPage={currentPage}
          uniqueIndex={uniqueIndex}
          formatDateTimeToUTC={formatDateTimeToUTC}
          formatDateToUTC={formatDateToUTC}
          formatPrice={formatPrice}
          fDate={fDate}
          fTimeDate={fTimeDate}
          enable_appointments={enable_appointments}
          showContainersModal={showContainersModal}
          Appointment={Appointment}
          shareLink={shareLink}
          handleGetShareLink={handleGetShareLink}
          Edit={Edit}
          delContainerLoad={DelContainerLoad}
          handleChangeContainerStatus={handleChangeContainerStatus}
          timerinterval={timerinterval}
          // fastProgress={fastProgress}
          getActivContainers={getActivContainers}
          setShowContainersModal={setShowContainersModal}
          setSelectedRow={setSelectedRow}
          Del={Del}
          mptyTrackingEnable={mptyTrackingEnable}
          Sizes={Sizes}
          SSLs={SSLs}
          updateContainer={updateContainer}
        />
      ) : (
        <div className="mt-16">
          <LoadingV2 />
        </div>
      )}
    </div>
  );
};
